import api from "../api/axiosInstance";

const systemSettingsService = {
    get: () => api.get("/system-settings"),
    update: (data) => api.patch("/system-settings", data),
    getRates: () => api.get("/system-settings/rates"),
    getDeliveryReceiptTemplate: () => api.get("/system-settings/delivery-receipt-template"),
    getDeliveryReceiptRiderTemplate: () => api.get("/system-settings/delivery-receipt-rider-template"),
    getHouseBolTemplate: () => api.get("/system-settings/house-bol-template"),
    getManifestTemplate: () => api.get("/system-settings/manifest-template"),
    getInvoiceTemplate: () => api.get("/system-settings/invoice-template"),
    getBankDetails: () => api.get("/system-settings/bank-details"),
    // Any authenticated user (customer included) — unlike get() above,
    // which needs manage_settings. Drives the Coming Soon gate.
    getFeatureFlags: () => api.get("/system-settings/feature-flags"),
    // Any authenticated user — the customer-facing Upgrade page. Editing it
    // goes through the generic update() above (premiumPageContent field),
    // same as every other admin-settings field.
    getPremiumPageContent: () => api.get("/system-settings/premium-page"),
    // Public — no auth — Login/Register themselves aren't authenticated.
    getIntegrationSnippets: () => api.get("/system-settings/integration-snippets"),
};

export default systemSettingsService;